import { environment } from "../../../environments/environment";

export const clientId = "eeb94da3-db62-41ac-9aca-e4192911680a";
export const redirectUri = environment.b2c_login_redirect_uri;
const b2cTenant = "cxsb2c";
const signupsigninUserFlow = "B2C_1A_signup_signin";
/**
 * Enter here the user flows and custom policies for your B2C application,
 * To learn more about user flows, visit https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */
export const b2cPolicies = {
  names: { signUpSignIn: signupsigninUserFlow },
  authorities: {
    signUpSignIn: {
      authority: `https://${b2cTenant}.b2clogin.com/${b2cTenant}.onmicrosoft.com/${signupsigninUserFlow}`,
    },
  },
  authorityDomain: `${b2cTenant}.b2clogin.com`,
};
